import React, { Component } from 'react';
import Toggle from '@atlaskit/toggle';
import type { IntlShape } from '@atlassian/jira-intl';
import confluencePagesUrl from '../../../../../assets/confluence-pages.svg';
import commonMessages from '../../../../../common/messages/pages-messages.tsx';
import TypeSelector from '../type-selector/index.tsx';
import messages from './messages.tsx';

export type Props = {
	isEnabled: boolean;
	onEnabledChange: () => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
class PagesSelector extends Component<Props> {
	renderAction = () => {
		const { formatMessage } = this.props.intl;
		return (
			<Toggle
				isChecked={this.props.isEnabled}
				onChange={this.props.onEnabledChange}
				label={formatMessage(messages.title)}
			/>
		);
	};

	render() {
		return (
			<TypeSelector
				Action={this.renderAction}
				title={messages.title}
				description={commonMessages.enablePagesLinkText}
				imageUrl={confluencePagesUrl}
			/>
		);
	}
}

export default PagesSelector;
